export function getLoginUrl() {
  const loginUrl = `${location.origin}/login`;
  const redirect = encodeURI(window.location.href);
  return `${loginUrl}?redirect=${redirect}`;
}
